import { Injectable } from '@angular/core';
import { CentralService } from '../central.service';

@Injectable({
  providedIn: 'root'
})

export class QuotaService extends CentralService {
  protected resource: string = "service";
}
